import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

export default function LandingPage() {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [scale, setScale] = useState(1);

  useEffect(() => {
    const updateScale = () => {
      setIsMobile(window.innerWidth < 768);
      const width = window.innerWidth;
      const height = window.innerHeight;
      const scaleX = width / 1920;
      const scaleY = height / 1080;
      setScale(Math.min(scaleX, scaleY));
    };

    updateScale();
    window.addEventListener("resize", updateScale);
    return () => window.removeEventListener("resize", updateScale);
  }, []);

  return isMobile ? <MobileLanding /> : <DesktopLanding scale={scale} />;
}

function DesktopLanding({ scale }) {
  return (
    <div
      style={{
        width: "100vw",
        height: "100vh",
        overflow: "hidden",
        backgroundColor: "#fff",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div
        style={{
          transform: `translate(${(window.innerWidth - 1920 * scale) / 2}px, ${(window.innerHeight - 1080 * scale) / 2}px) scale(${scale})`,
          transformOrigin: "top left",
          width: "1920px",
          height: "1080px",
          position: "absolute",
          top: 0,
          left: 0,
          display: "flex",
          backgroundColor: "#fff",
        }}
      >
        {/* Command Rail */}
        <div style={{
          width: "200px",
          height: "100%",
          backgroundColor: "#00C896",// Mint Green
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          gap: "40px",
        }}>
          <CommandButton to="/login" label="Login" />
          <CommandButton to="/register" label="Register" />
          <CommandButton href="https://discord.gg/xZppewUCaW" label="Discord" />
        </div>

        {/* Main area */}
        <div style={{
  flex: 1,
  position: "relative",
  backgroundColor: "#fff",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
}}>

  {/* Centered column for title + logo */}
  <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
    <h1 style={{
      letterSpacing: "10px",
      fontFamily: "'Ceviche One', cursive",
      fontSize: "150px",
      fontWeight: "bold",
      color: "#1e1e1e", // Charcoal
      marginBottom: "1px",
    }}>
      ROLL-CALL
    </h1>

    <h2 style={{
  fontFamily: "'Raleway', sans-serif",
  fontWeight: "700",
  fontSize: "36px",
  color: "#1E1E1E",
  textAlign: "center",
  letterSpacing: "3px",
  marginBottom: "30px",
}}>
  Tabletop Gaming. Anywhere.
</h2>

    <img
      src="mylogo.png"
      alt="Roll-Call Logo"
      style={{ height: "700px", objectFit: "contain" }}
    />
  </div>

  {/* Dave's logo with link */}
<a
  href="https://preview.drivethrurpg.com/en/publisher/4266/One-Shot-RPG"
  target="_blank"
  rel="noopener noreferrer"
  style={{
    position: "absolute",
    bottom: "30px",
    right: "30px",
  }}
>
  <img
    src="/davelogo.png"
    alt="One Shot Logo"
    style={{
      height: "100px",
      opacity: 0.8,
    }}
  />
</a>
</div>

      </div>
    </div>
  );
}

function MobileLanding() {
  const buttonStyle = {
    fontFamily: "'Raleway, sans-serif",
    fontStyle: "italic",
    fontWeight: "700",
    fontSize: "22px",
    color: "#fff",
    backgroundColor: "#00C896", // Mint Green
    border: "none",
    borderRadius: "8px",
    padding: "12px 24px",
    margin: "10px 0",
    width: "80%",
    textAlign: "center",
    cursor: "pointer",
    boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
  };

  const Wrapper = ({ to, href, children }) => {
    if (to) return <Link to={to} style={{ textDecoration: "none", width: "100%", display: "flex", justifyContent: "center" }}>{children}</Link>;
    if (href) return <a href={href} target="_blank" rel="noopener noreferrer" style={{ textDecoration: "none", width: "100%", display: "flex", justifyContent: "center" }}>{children}</a>;
    return <>{children}</>;
  };

  return (
    <div
      style={{
        width: "100vw",
        height: "100vh",
        backgroundColor: "#fff",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "40px 20px 20px",
        boxSizing: "border-box",
      }}
    >
      {/* Title */}
      <h1 style={{
        letterSpacing: "4px",
        fontFamily: "'Ceviche One', cursive",
        fontSize: "76px",
        fontWeight: "bold",
        color: "#1e1e1e", // Charcoal
        marginBottom: "4px",
        textAlign: "center",
      }}>
        ROLL-CALL
      </h1>

      <h2 style={{
  fontFamily: "'Raleway', sans-serif",
  fontWeight: "700",
  fontSize: "18px",
  letterSpacing: "2px",
  color: "#1E1E1E",
  textAlign: "center",
  marginBottom: "30px",
}}>
  Tabletop Gaming. Anywhere.
</h2>

      {/* Logo */}
      <img
        src="/mylogo.png"//"/mylogo.png"
        alt="Roll-Call Logo"
        style={{ width: "80%", maxWidth: "400px", objectFit: "contain", marginBottom: "30px" }}
      />

      {/* Buttons */}
      <div style={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}>
        <Wrapper to="/login"><button style={buttonStyle}>Login</button></Wrapper>
        <Wrapper to="/register"><button style={buttonStyle}>Register</button></Wrapper>
        <Wrapper href="https://discord.gg/xZppewUCaW"><button style={buttonStyle}>Discord</button></Wrapper>
      </div>

      {/* Dave's logo with link */}
<a
  href="https://preview.drivethrurpg.com/en/publisher/4266/One-Shot-RPG"
  target="_blank"
  rel="noopener noreferrer"
  style={{ display: "inline-block", marginTop: "20px" }}
>
  <img
    src="/davelogo.png"
    alt="One Shot"
    style={{ width: "80px", opacity: 0.7 }}
  />
</a>
    </div>
  );
}

function CommandButton({ label, to, href }) {
  const Wrapper = ({ children }) => {
    if (to) return <Link to={to} style={{ textDecoration: "none" }}>{children}</Link>;
    if (href) return <a href={href} target="_blank" rel="noopener noreferrer" style={{ textDecoration: "none" }}>{children}</a>;
    return <>{children}</>;
  };

  return (
    <Wrapper>
      <div
        style={{
          width: "140px",
          height: "60px",
          backgroundColor: "#3B5A78", // Steel Blue
          borderRadius: "10px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          fontFamily: "'Raleway', sans-serif",
          fontWeight: "700",
          color: "#1E1E1E",
          fontSize: "28px",
          cursor: "pointer",
          boxShadow: "0 4px 8px rgba(0,0,0,0.3)",
          transition: "transform 0.2s",
        }}
        onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.05)")}
        onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1.0)")}
      >
        {label}
      </div>
    </Wrapper>
  );
}
